
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27","height":"27","viewBox":"0 0 27 27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.1 16.9h-1.2l-.4-.4c1.5-1.7 2.4-3.9 2.4-6.3 0-5.4-4.4-9.8-9.8-9.8S.3 4.8.3 10.2 4.7 20 10.1 20c2.4 0 4.6-.9 6.3-2.3l.4.4v1.2l7.5 7.5 2.2-2.2-7.4-7.7zm-9 0c-3.7 0-6.8-3-6.8-6.8 0-3.7 3-6.8 6.8-6.8 3.7 0 6.8 3 6.8 6.8s-3 6.8-6.8 6.8z"}})])
          )
        }
      }
    